import { render, staticRenderFns } from "./inHuiFa.vue?vue&type=template&id=1f930a15&scoped=true&"
import script from "./inHuiFa.vue?vue&type=script&lang=js&"
export * from "./inHuiFa.vue?vue&type=script&lang=js&"
import style0 from "./inHuiFa.vue?vue&type=style&index=0&id=1f930a15&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f930a15",
  null
  
)

export default component.exports